import script from "./Aviso.vue?vue&type=script&setup=true&lang=js"
export * from "./Aviso.vue?vue&type=script&setup=true&lang=js"

import "./Aviso.vue?vue&type=style&index=0&id=5589b6ef&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5589b6ef"]])

export default __exports__